export default __webpack_public_path__ + "static/Denver-33d6c8ebb7647b2bf226a0f0cede71aa.webp";